import React from 'react';
import HomeCallApp from './HomeCall';

export default function App() {
  return <HomeCallApp />;
}